import { useDispatch } from 'react-redux';
import { useAppSelector } from '@hooks/reduxHooks';
import { baseErrorHandler } from '@queries/baseErrorHandler';
import { showMessage } from '@queries/showMessage';
import { $api } from '@service/RequestService';
import { useMutation, useQueryClient } from 'react-query';
import { NumberParam, NumericArrayParam, StringParam, useQueryParams, withDefault } from 'use-query-params';

import { realtorBookingConstants, setRealtorBookingView } from '..';

export function useRealtorBookingAction() {
  const qc = useQueryClient();
  const dispatch = useDispatch();
  const { id } = useAppSelector(({ realtorBookingReducer }) => realtorBookingReducer.view);

  const [query] = useQueryParams({
    search: StringParam,
    page: withDefault(NumberParam, 1),
    size: withDefault(NumberParam, 10),
    startDate: StringParam,
    finishDate: StringParam,
    realtors: NumericArrayParam,
    houses: NumericArrayParam,
    buildings: NumericArrayParam
  });

  return useMutation(
    async (payload: 'ACCESSED' | 'REJECTED') => {
      const { data } = await $api.put('/v1/realtor-booking/action', {
        realtorBookingId: id,
        action: payload
      });

      return data;
    },
    {
      onError: baseErrorHandler,
      onSuccess: async data => {
        // await qc.invalidateQueries([realtorBookingConstants.queryKeys.ONE_BOOKING, id]);
        await qc.invalidateQueries([realtorBookingConstants.queryKeys.BOOKINGS, query]);
        await qc.invalidateQueries(realtorBookingConstants.queryKeys.BOOKING_COUNT);

        showMessage(data?.message, data?.accept);

        dispatch(
          setRealtorBookingView({
            visible: false,
            id
          })
        );
      }
    }
  );
}
